import {
    ROUTE_ADMINISTRATION_GROUP,
    ROUTE_ADMINISTRATION_GROUP_SUCCESS,
    ROUTE_ADMINISTRATION_GROUP_ERROR,
    DOSAGE_FORM_GROUP,
    DOSAGE_FORM_GROUP_SUCCESS,
    DOSAGE_FORM_GROUP_ERROR,
    ROUTE_ADMINISTRATION,
    ROUTE_ADMINISTRATION_SUCCESS,
    ROUTE_ADMINISTRATION_ERROR,
    DOSAGE_FORM,
    DOSAGE_FORM_SUCCESS,
    DOSAGE_FORM_ERROR,
    DISPENSING_UNIT,
    DISPENSING_UNIT_SUCCESS,
    DISPENSING_UNIT_ERROR,
    UNSPSC,
    UNSPSC_SUCCESS,
    UNSPSC_ERROR,
    UNSPSC_FAMILY,
    UNSPSC_FAMILY_SUCCESS,
    UNSPSC_FAMILY_ERROR,
    UNSPSC_CLASS,
    UNSPSC_CLASS_SUCCESS,
    UNSPSC_CLASS_ERROR,
    ACTIVE_INGREDIENT_CODE20,
    ACTIVE_INGREDIENT_CODE20_SUCCESS,
    ACTIVE_INGREDIENT_CODE20_ERROR,
    DOSAGE_FORM_CODE20,
    DOSAGE_FORM_CODE20_SUCCESS,
    DOSAGE_FORM_CODE20_ERROR,
    MED_DESCRIPTION_CODE22,
    MED_DESCRIPTION_CODE22_SUCCESS,
    MED_DESCRIPTION_CODE22_ERROR,
    SOURCE_CODE22,
    SOURCE_CODE22_SUCCESS,
    SOURCE_CODE22_ERROR,
    ANIO_PRICE_CODE22,
    ANIO_PRICE_CODE22_SUCCESS,
    ANIO_PRICE_CODE22_ERROR,
    UNIT_PRICE,
    UNIT_PRICE_SUCCESS,
    UNIT_PRICE_ERROR,
    UNIT_PRICE_TRANSACCIONES,
    UNIT_PRICE_TRANSACCIONES_SUCCESS,
    UNIT_PRICE_TRANSACCIONES_ERROR,
    BASKET,
    BASKET_SUCCESS,
    BASKET_ERROR

} from '../actions';

const INIT_STATE = {
  modal: false,
  init:true,
    route_administration_group: {
        data: [],
        loading: true,
        message: ''
    },
    dosage_form_group: {
        data: [],
        loading: true,
        message: ''
    },
    route_administration: {
        data: [],
        loading: true,
        message: ''
    },
    dosage_form: {
        data: [],
        loading: true,
        message: ''
    },
    dispensing_unit: {
        data: [],
        loading: true,
        message: ''
    },
    unspsc: {
        data: [],
        loading: true,
        message: ''
    },
    unspsc_family: {
        data: [],
        loading: true,
        message: ''
    },
    unspsc_class: {
        data: [],
        loading: true,
        message: ''
    },
    active_ingredient_code20: {
        data: [],
        loading: true,
        message: ''
    },
    dosage_form_code20: {
        data: [],
        loading: true,
        message: ''
    },
    med_description_code22: {
        data: [],
        loading: true,
        message: ''
    },
    source_code22: {
        data: [],
        loading: true,
        message: ''
    },
    anio_price_code22: {
        data: [],
        loading: true,
        message: ''
    },
    unit_price: {
        data: [],
        loading: true,
        message: ''
    },
    unit_price_transacciones: {
        data: [],
        loading: true,
        message: ''
    },
    basket: {
        data: [],
        loading: true,
        message: ''
    },
  value:{
      route_administration_group: false,
      dosage_form_group: false,
      route_administration: false,
      dosage_form: false,
      dispensing_unit: false,
      unspsc: false,
      unspsc_family: false,
      unspsc_class: false,
      active_ingredient_code20:false,
      dosage_form_code20: false,
      med_description_code22: false,
      source_code22: false,
      anio_price_code22: false,
      med_description: false,
      unit_price: false,
      unit_price_transacciones: false,
      basket: false
    }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
      case ROUTE_ADMINISTRATION_GROUP:
      return {
        ...state,
        init:false,
          route_administration_group:{
              ...state.route_administration_group,
          loading: true,
          data:[],
          message: ''
        }
      }
      case ROUTE_ADMINISTRATION_GROUP_SUCCESS:
      return {
        ...state,
          route_administration_group:{
              ...state.route_administration_group,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
      case ROUTE_ADMINISTRATION_GROUP_ERROR:
      return {
        ...state,
          route_administration_group:{
              ...state.route_administration_group,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }

      case DOSAGE_FORM_GROUP:
          return {
              ...state,
              init: false,
              dosage_form_group: {
                  ...state.dosage_form_group,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case DOSAGE_FORM_GROUP_SUCCESS:
          return {
              ...state,
              dosage_form_group: {
                  ...state.dosage_form_group,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case DOSAGE_FORM_GROUP_ERROR:
          return {
              ...state,
              dosage_form_group: {
                  ...state.dosage_form_group,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
        case ROUTE_ADMINISTRATION:
            return {
                ...state,
                init: false,
                route_administration: {
                    ...state.route_administration,
                    loading: true,
                    data: [],
                    message: ''
                }
            }
        case ROUTE_ADMINISTRATION_SUCCESS:
            return {
                ...state,
                route_administration: {
                    ...state.route_administration,
                    loading: false,
                    data: action.payload,
                    message: ''
                }
            }
        case ROUTE_ADMINISTRATION_ERROR:
            return {
                ...state,
                route_administration: {
                    ...state.route_administration,
                    loading: false,
                    data: [],
                    message: 'No se encotraron datos'
                }
            }

        case DOSAGE_FORM:
            return {
                ...state,
                init: false,
                dosage_form: {
                    ...state.dosage_form,
                    loading: true,
                    data: [],
                    message: ''
                }
            }
        case DOSAGE_FORM_SUCCESS:
            return {
                ...state,
                dosage_form: {
                    ...state.dosage_form,
                    loading: false,
                    data: action.payload,
                    message: ''
                }
            }
        case DOSAGE_FORM_ERROR:
            return {
                ...state,
                dosage_form: {
                    ...state.dosage_form,
                    loading: false,
                    data: [],
                    message: 'No se encotraron datos'
                }
          }
      case DISPENSING_UNIT:
          return {
              ...state,
              init: false,
              dispensing_unit: {
                  ...state.dispensing_unit,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case DISPENSING_UNIT_SUCCESS:
          return {
              ...state,
              dispensing_unit: {
                  ...state.dispensing_unit,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case DISPENSING_UNIT_ERROR:
          return {
              ...state,
              dispensing_unit: {
                  ...state.dispensing_unit,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case UNSPSC:
          return {
              ...state,
              init: false,
              unspsc: {
                  ...state.unspsc,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case UNSPSC_SUCCESS:
          return {
              ...state,
              unspsc: {
                  ...state.unspsc,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case UNSPSC_ERROR:
          return {
              ...state,
              unspsc: {
                  ...state.unspsc,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case UNSPSC_FAMILY:
          return {
              ...state,
              init: false,
              unspsc_family: {
                  ...state.unspsc_family,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case UNSPSC_FAMILY_SUCCESS:
          return {
              ...state,
              unspsc_family: {
                  ...state.unspsc_family,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case UNSPSC_FAMILY_ERROR:
          return {
              ...state,
              unspsc_family: {
                  ...state.unspsc_family,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case UNSPSC_CLASS:
          return {
              ...state,
              init: false,
              unspsc_class: {
                  ...state.unspsc_class,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case UNSPSC_CLASS_SUCCESS:
          return {
              ...state,
              unspsc_class: {
                  ...state.unspsc_class,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case UNSPSC_CLASS_ERROR:
          return {
              ...state,
              unspsc_class: {
                  ...state.unspsc_class,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case ACTIVE_INGREDIENT_CODE20:
          return {
              ...state,
              init: false,
              active_ingredient_code20: {
                  ...state.active_ingredient_code20,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case ACTIVE_INGREDIENT_CODE20_SUCCESS:
          return {
              ...state,
              active_ingredient_code20: {
                  ...state.active_ingredient_code20,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case ACTIVE_INGREDIENT_CODE20_ERROR:
          return {
              ...state,
              active_ingredient_code20: {
                  ...state.active_ingredient_code20,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case DOSAGE_FORM_CODE20:
          return {
              ...state,
              init: false,
              dosage_form_code20: {
                  ...state.dosage_form_code20,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case DOSAGE_FORM_CODE20_SUCCESS:
          return {
              ...state,
              dosage_form_code20: {
                  ...state.dosage_form_code20,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case DOSAGE_FORM_CODE20_ERROR:
          return {
              ...state,
              dosage_form_code20: {
                  ...state.dosage_form_code20,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case MED_DESCRIPTION_CODE22: 
          return {
              ...state,
              init: false,
              med_description_code22: {
                  ...state.med_description_code22,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case MED_DESCRIPTION_CODE22_SUCCESS: 
          return {
              ...state,
              med_description_code22: {
                  ...state.med_description_code22,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case MED_DESCRIPTION_CODE22_ERROR: 
          return {
              ...state,
              med_description_code22: {
                  ...state.med_description_code22,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case SOURCE_CODE22:
          return {
              ...state,
              init: false,
              source_code22: {
                  ...state.source_code22,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case SOURCE_CODE22_SUCCESS:
          return {
              ...state,
              source_code22: {
                  ...state.source_code22,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case SOURCE_CODE22_ERROR:
          return {
              ...state,
              source_code22: {
                  ...state.source_code22,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case ANIO_PRICE_CODE22:
          return {
              ...state,
              init: false,
              anio_price_code22: {
                  ...state.anio_price_code22,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case ANIO_PRICE_CODE22_SUCCESS:
          return {
              ...state,
              anio_price_code22: {
                  ...state.anio_price_code22,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case ANIO_PRICE_CODE22_ERROR:
          return {
              ...state,
              anio_price_code22: {
                  ...state.anio_price_code22,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case UNIT_PRICE:
          return {
              ...state,
              init: false,
              unit_price: {
                  ...state.unit_price,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case UNIT_PRICE_SUCCESS:
          return {
              ...state,
              unit_price: {
                  ...state.unit_price,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case UNIT_PRICE_ERROR:
          return {
              ...state,
              unit_price: {
                  ...state.unit_price,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case UNIT_PRICE_TRANSACCIONES:
          return {
              ...state,
              init: false,
              unit_price_transacciones: {
                  ...state.unit_price_transacciones,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case UNIT_PRICE_TRANSACCIONES_SUCCESS:
          return {
              ...state,
              unit_price_transacciones: {
                  ...state.unit_price_transacciones,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case UNIT_PRICE_TRANSACCIONES_ERROR:
          return {
              ...state,
              unit_price_transacciones: {
                  ...state.unit_price_transacciones,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case BASKET:
          return {
              ...state,
              init: false,
              basket: {
                  ...state.basket,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case BASKET_SUCCESS:
          return {
              ...state,
              basket: {
                  ...state.basket,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case BASKET_ERROR:
          return {
              ...state,
              basket: {
                  ...state.basket,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }

    default:
      return { ...state };
  }
};